<app-header ></app-header>
<app-navigation-bar (onBurgerClicked)="toggleDrawer()"></app-navigation-bar>
<app-drawer [open]="drawerIsOpen" (onClose)="drawerIsOpen=false"></app-drawer>

<div class="offers-header" *ngIf="!showLoginMessage">
  <div class="page-content-wider">
    <h1 class="offers-header-title">{{getString('wishlistHeaderTitle')}}</h1>
    {{getString('wishlistHeaderText')}}
  </div>
</div>

<div class="page-content-wider">

  <div *ngIf="!showLoginMessage" class="store-media-selectors-container">
    <div class="personal-lists-toolbar">
      <div class="list-type-selector-container personal-lists-type-selector">
        <div class="list-selection-text">{{getString('listSelection')}}</div>
        <nav class="list-type-selector" aria-label="Lists">
          <div class="list-type-wrapper" *ngFor="let listType of getListTypes(); let i = index">
            <a class="list-type-item" [routerLink]="getListTypeUrl(listType)" [class.active]="isActiveListType(listType)">
              <span class="material-icons list-type-icon" aria-hidden="true">{{listType.icon}}</span>
              <span class="list-type-label"><span *ngFor="let labelPart of getListTypeLabelParts(listType)">{{labelPart}}</span></span>
            </a>
            <div class="headerDivider" *ngIf="i != getListTypes().length - 1"></div>
          </div>
        </nav>
      </div>
      <div class="store-media-selectors-content">
        <app-store-selector class="store-selector-container" [useBrandIcons]="true" (onStoreChanged)="storeChanged()"></app-store-selector>
        <app-media-selector class="media-selector-container" [selectedMediaType]="selectedMediaType" [mediaTypes]="mediaTypesForDisplay"
          [nolinks]="true" (onMediaChanged)="mediaChanged($event)">
        </app-media-selector>

        <div class="actions-selector-container">
          <div class="actions-selection-text">{{getString('actions')}}</div>
          <div class="actions-icons-container">
            <div class="action-icon-wrapper dropdown" [class.active]="isDropdownOpen(importDDContent)" (click)="importDropdownClicked()" *ngIf="showImportButton()">
              <span class="material-icons action-icon">tilt_arrow_down</span>
              <div class="action-name">{{getString('import')}}</div>
              <div #importDDContent class="dropdown-content dd-right">
                <span class="menu-item" (click)="importIMDbListModal.open();">{{getString("importIMDbList")}}</span>
                <span class="menu-item" (click)="importLetterboxdListModal.open();">{{getString("importLetterboxdList")}}</span>
              </div>
            </div>
            <div class="action-icon-wrapper dropdown" [class.active]="isDropdownOpen(exportDDContent)" (click)="exportDropdownClicked()">
              <span class="material-icons action-icon export-icon">tilt_arrow_down</span>
              <div class="action-name">{{getString('export')}}</div>
              <div #exportDDContent class="dropdown-content dd-right">
                <span class="menu-item" (click)="exportWithUrl()">{{getString("exportWithURL")}}</span>
                <span class="menu-item" (click)="exportToCsv()">{{getString("exportAsCSV")}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!showLoginMessage" class="filters-container-test">

    <div class="small-horizontal-border"></div>

    <div class="normal-filters">
      <div *ngIf="shouldShowWishlistGenreFilter()" class="filter-test">
        <app-multichoice-menu class="dd-test" [title]="getString('genres')" [label]="getString('genres')" [itemList]="genres" [selectedItemsList]="selectedGenres" (selectionChanged)="genreChanged($event)"></app-multichoice-menu>
      </div>
      <div *ngIf="shouldShowWishlistPriceFilter()" class="filter-test">
        <app-slider-multichoice class="dd-test" [title]="getString('priceFilter')" [isPrice]="true" [label]="getString('priceFilter')" [itemList]="priceRanges" [selectedItemsList]="selectedPriceRanges" (selectionChanged)="priceRangeChanged($event)"></app-slider-multichoice>
      </div>
      <div *ngIf="shouldShowWishlistQualityFilter()" class="filter-test">
        <app-dropdown class="dd-test" [label]="getString('quality')" [items]="qualityOptions" [selectedItem]="selectedQuality" [default]="qualityOptions[0]" [stringAttr]="'title'" [right]="true" (onItemSelected)="qualityChanged($event)"></app-dropdown>
      </div>
      <div class="filter-test">
        <app-dropdown class="dd-test" [label]="getString('status')" [items]="statusValues" [selectedItem]="status" [default]="statusValues[0]" (onItemSelected)="statusChanged($event)"></app-dropdown>
      </div>
      <div *ngIf="shouldShowWishlistItemTypeFilter()" class="filter-test">
        <app-dropdown class="dd-test" [label]="'Buy / Rent'" [items]="itemTypeValues" [selectedItem]="currentItemType" [default]="itemTypeValues[0]" (onItemSelected)="itemTypeChanged($event)"></app-dropdown>
      </div>
      <div *ngIf="shouldShowWishlistBundleFilter()" class="filter-test">
        <app-dropdown class="dd-test" [label]="getString('bundleFilter')" [items]="bundleFilterOptions" [selectedItem]="selectedBundleFilterOption" [default]="bundleFilterOptions[0]" [stringAttr]="'title'" [stringAttrIntl]="true" [right]="true" (onItemSelected)="bundleFilterChanged($event)"></app-dropdown>
      </div>
      <div *ngIf="shouldShowWishlistVisionPro3dFilter()" class="filter-test vision-pro-3d-filter">
        <app-dropdown class="dd-test" [label]="getString('movies3D')" [items]="visionPro3dOptions" [selectedItem]="selectedVisionPro3dOption" [default]="visionPro3dOptions[0]" [stringAttr]="'title'" [stringAttrIntl]="true" [right]="true" (onItemSelected)="visionPro3dChanged($event)"></app-dropdown>
      </div>
      <div class="filter-test-mobile-sort">
        <app-dropdown class="dd-test" [label]="getString('sortBy')" [items]="sortingValues" [selectedItem]="sortKey" [default]="sortingValues[0]" [right]="true" (onItemSelected)="sortChanged($event)"></app-dropdown>
      </div>
    </div>

    <div class="special-filter">
      <app-dropdown class="sort float-right dd" [class.active-filter-label]="sortKey != sortingValues[0]" [selectedItemWidth]="'180px'" [title]="getString('sortBy')" [items]="sortingValues" [selectedItem]="sortKey" [default]="sortingValues[0]" [right]="true" (onItemSelected)="sortChanged($event)"></app-dropdown>
    </div>

  </div>

  <div class="txt-algn-cntr wishlist-title-container" [class.invisible]="!items"><h3>{{getString('wishlist')}} - {{getString(getStore())}} {{getMedia()}} ({{itemCount}})</h3></div>

  <div *ngIf="showLoginMessage" class="wishlist-promo-container">
    <div class="wishlist-promo-content">

      <div class="wishlist-hero">
        <span class="material-icons wishlist-hero-star" aria-hidden="true">star</span>
        <h1 class="wishlist-hero-title">{{getString('wishlistTeaserTitle')}}</h1>
        <p class="wishlist-hero-subtitle">{{getString('wishlistTeaserSubtitle')}}</p>
      </div>

      <div class="wishlist-feature-showcase">
        <div class="feature-panel wishlist-panel">
          <span class="material-icons feature-panel-icon" aria-hidden="true">star</span>
          <h2>{{getString('wishlistTeaserWishlistTitle')}}</h2>
          <p>{{getString('wishlistTeaserWishlistText')}}</p>
        </div>

        <div class="feature-panel my-lists-panel">
          <span class="material-icons feature-panel-icon" aria-hidden="true">format_list_bulleted</span>
          <h2>{{getString('wishlistTeaserMyListsTitle')}}</h2>
          <p>{{getString('wishlistTeaserMyListsText')}}</p>
        </div>

        <div class="feature-panel my-purchases-panel">
          <span class="material-icons feature-panel-icon" aria-hidden="true">shopping_bag</span>
          <h2>{{getString('wishlistTeaserMyPurchasesTitle')}}</h2>
          <p>{{getString('wishlistTeaserMyPurchasesText')}}</p>
        </div>
      </div>

      <div class="wishlist-cta">
        <button type="button" class="blue-button cta-primary" (click)="register()">
          {{getString('wishlistTeaserCta')}}
        </button>
        <p class="cta-login">
          <span>{{getString('wishlistTeaserAlreadyHaveAccount')}}</span>
          <a class="cta-login-link" (click)="login()">{{getString('login')}}</a>
        </p>
      </div>

    </div>
  </div>

  <div *ngIf="listIsEmpty == true" class="empty-wishlist-message">
    {{getString('wishlistIsEmpty')}}
  </div>

  <div class="items-container">
    <div class="item-container" *ngFor="let item of items; let i = index;">
      <ng-container *ngIf="!hideBecausePurchased(item)">
        <app-grid-item-wishlist [item]="item" [priceHint]="'offerslist'" [store]="getStore()" (onItemClicked)="itemClicked(item)"
        (onRemoveFromWishlistClicked)="removeFromWishlistClicked(item)"></app-grid-item-wishlist>
      </ng-container>
    </div>
  </div>

  <div class="results-end" *ngIf="resultsEndReached">{{getString('endOfResults')}}</div>

</div>

<div *ngIf="showSpinner && !showLoginMessage" class="spinner-container txt-algn-cntr">
  <app-spinner></app-spinner>
</div>

<app-scroll-top *ngIf="showScrollToTopButton"></app-scroll-top>

<app-modal #confirmRemoveFromWishListModal [title]="getString('confirmation')" [confirmationModal]="true"
(onResult)="onConfirmRemoveFromWishlistModalResult($event)">

  <div>{{getString('wishlistRemoveItemConfirm')}}</div>

</app-modal>

<app-authentication #authentication></app-authentication>

<app-modal #importIMDbListModal [title]="getString('importIMDbList')">
  <app-import-imdb-list *ngIf="importIMDbListModal.isOpen == true" (onClose)="loadItems();importIMDbListModal.close()">
  </app-import-imdb-list>
</app-modal>

<app-modal #importLetterboxdListModal [title]="getString('importLetterboxdList')">
  <app-import-letterboxd-list *ngIf="importLetterboxdListModal.isOpen == true" (onClose)="loadItems();importLetterboxdListModal.close()">
  </app-import-letterboxd-list>
</app-modal>

<app-modal #exportComingSoonModal [title]="getString('export')" [okModal]="true">
  {{getString('comingSoon')}}
</app-modal>
